import React from 'react'
import Explore from '../../components/explore/Explore'
import Moviecard from '../../components/moviecard/Moviecard'
import HeroBanner from "./herobanner/HeroBanner"

export default function Home() {
  return (
  <>
      <HeroBanner></HeroBanner>
      <Explore></Explore>

  </>
  )
}
